import type { PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';
import type { Rect, SetElement } from 'react-use-rect';
import { useRect } from 'react-use-rect';

type WidgetRectContextValue = {
  rect: Rect | undefined;
  ref: SetElement;
};

const WidgetRectContext = createContext<WidgetRectContextValue | null>(null);

export type WidgetRectProviderProps = PropsWithChildren;

export function WidgetRectProvider({ children }: WidgetRectProviderProps) {
  const [rect, setRect] = useState<Rect | undefined>(undefined);
  const [ref] = useRect(setRect, { resize: true });

  return (
    <WidgetRectContext.Provider value={{ rect, ref }}>
      {children}
    </WidgetRectContext.Provider>
  );
}

export const useWidgetRect = () => {
  return useWidgetRectContext()?.rect;
};

export const useWidgetRectRef = () => {
  return useWidgetRectContext()?.ref;
};

export const useWidgetRectContext = () => {
  const context = useContext(WidgetRectContext);

  if (context === null) {
    throw new Error(
      `useWidgetRectContext should be used within WidgetRectContext`
    );
  }

  return context;
};
